import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Page from 'component/Page';
import Table from 'component/Table';
import sendRequest from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import { Button } from 'react-bootstrap';
import Paths from 'util/paths';
import { useHistory } from 'react-router-dom';

const ServerLogsDetails = () => {
    const history = useHistory();
    const [ logs, setLogs ] = useState([]);

    const fetchLogs = useCallback(async () => {
        try {
            const response = await sendRequest({
                url: Urls.serverlogs.list,
            });
            const { result } = response;
            setLogs(result);

        } catch (error) {
            console.error('Error fetching logs:', error);
        }
    }, []);
    const filteredLogs = useMemo(() =>
        logs.filter(fileName => fileName.startsWith('combined') || fileName.startsWith('error')),
        [ logs ]
    );

    useEffect(() => {
        fetchLogs();
    }, [ fetchLogs ]);

    const handleLogClick = useCallback(async (log) => {
        try {
            history.push(`${Paths.serverlogs.getfiles}/?fileName=${log}`);
        } catch (error) {
            console.error('Error handling log click:', error);
        }
    }, [ history ]);

    const dataTable = useMemo(() =>
        filteredLogs.map((log, index) => ({
            key: index,
            data: [
                <Button key={index} onClick={() => handleLogClick(log)}>
                    {log}
                </Button>,
            ],
        })),
        [ filteredLogs, handleLogClick ]
    );

    return (
        <Page
            title={string.APP_SUMMARY_PAGE_TITLE}
            body={
                <Table
                    className="nowrap"
                    headers={[ string.APP_SUMMARY_TITLE ]}
                    data={dataTable}
                    isPaging={false}
                />
            }
        />
    );
};

export default ServerLogsDetails;
